module.exports = __webpack_public_path__ + "img/Sampling.5853ab40.png";